import TableFreigegebenCodes from '../components/TableFreigegebenCodes';

const Freigegeben = () => (
  <div>
    <TableFreigegebenCodes />
  </div>
);

export default Freigegeben;
